import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';

export const applicationStatusItems: Record<string, ApplicationStatusDetail> = {
    draft: {
        label: 'In Erfassung',
        description: 'Der Antrag wurde noch nicht versendet.',
        order: 100,
    },
    sent: {
        label: 'Antrag versendet',
        description: 'Ihr Antrag wurde erfolgreich versendet und wird geprüft.',
        order: 200,
    },
    inReview: {
        label: 'Antrag in Prüfung',
        description: 'Der Antrag wird auf Vollständigkeit geprüft.',
        order: 300,
    },
    incomplete: {
        label: 'Antrag unvollständig',
        description: 'Der Antrag ist unvollständig.',
        order: 400,
    },
    inProgress: {
        label: 'Antrag in Bearbeitung',
        description:
            'Der Antrag ist vollständig und der Netzverknüpfungspunkt wird ermittelt.',
        order: 500,
    },
    proposalSent: {
        label: 'Angebot versendet',
        description:
            'Einspeisezusage oder Mitteilung des Netzverknüpfungspunktes wurde versendet.',
        order: 600,
    },
    operatorDeclarationReceived: {
        label: 'Betreibererklärung erhalten',
        description: 'Die Betreibererklärung ist eingegangen.',
        order: 700,
    },
    finishNotificationReceived: {
        label: 'Fertigmeldung erhalten',
        description:
            'Die Fertigmeldung durch Ihren Installateur ist eingegangen und geprüft.',
        order: 800,
    },
    operational: {
        label: 'In Betrieb',
        description: 'Ihre Anlage ist in Betrieb.',
        order: 900,
    },
    deleted: {
        label: 'Gelöscht',
        description: 'Der Antrag wurde gelöscht.',
        order: 1000,
    },
    rejected: {
        label: 'Antrag verworfen',
        description:
            'Der Antrag ist nicht mehr gültig. Falls eine Realisierung vorgesehen ist, stellen Sie bitte einen neuen Antrag.',
        order: 9900,
    },
};
